module.exports = ".text-folder-name{\n    font-size: 14px;\n    color: #091e42;\n    font-family: Montserrat-Regular;\n    margin-bottom: 1px;\n}\n.text-bookmarks-count{\n    font-size: 12px;\n    color: #707070;\n    font-family: Montserrat-SemiBold; \n}\n.bookmark-folder{\n    padding-top: 20px;\n    padding-bottom: 15px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/all-bookmark-list/all-bookmark-list.component.css
// module id = ./src/app/feature/main/roles-shared/components/all-bookmark-list/all-bookmark-list.component.css
// module chunks = main